<div class="tab-pane fade show active" id="strategies-tab-pane" role="tabpanel" aria-labelledby="strategies-tab"
    tabindex="0">
    <div class="row align-items-center mt-2 g-2">
        <div class="col-lg-12">
            <ul class="nav nav-tabs bottab" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link" [class.active]="activeTab === 'open-orders'" type="button"
                        (click)="setActiveTab('open-orders')">
                        Open Orders
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" [class.active]="activeTab === 'positions'" type="button"
                        (click)="setActiveTab('positions')">
                        Positions
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" [class.active]="activeTab === 'order-history'" type="button"
                        (click)="setActiveTab('order-history')">
                        Order History
                    </button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link" [class.active]="activeTab === 'trade-history'" type="button"
                        (click)="setActiveTab('trade-history')">
                        Trade History
                    </button>
                </li>
            </ul>
        </div>
    </div>

    <div class="tab-content" id="myTabContent" [ngSwitch]="activeTab">
        <!-- Open Orders & History Tab -->
        <div class="tab-pane fade show active">
            <!-- Open Orders -->
            <div class="table-responsive" *ngSwitchCase="'open-orders'">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Symbol</th>
                            <th>Type</th>
                            <th>Side</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Filled</th>
                            <th>Status</th>
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="9" class="text-center">
                                <app-loader></app-loader>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="!isLoading && orders.length > 0; else noData">
                        <tr *ngFor="let order of filteredOrders">
                            <td>{{ order.createdAt | date:'MM-dd HH:mm:ss' }}</td>
                            <td>{{ order.symbol }}</td>
                            <td>{{ order.orderType }}</td>
                            <td [ngClass]="order.side === 'BUY' ? 'text-success' : 'text-danger'">
                                {{ order.side }}
                            </td>
                            <td>{{ order.originalPrice | number:'1.2-2' }}</td>
                            <td>{{ order.originalQty }}</td>
                            <td>{{ order.response?.executedQty || 0 }}</td>
                            <td>{{ order.status }}</td>
                            <td>
                                <!-- Matches reference button style -->
                                <button class="botType" (click)="cancelOrder(order)">
                                    Cancel
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <ng-template #noData>
                        <tbody *ngIf="!isLoading">
                            <tr>
                                <td colspan="9" style="border-color: transparent">
                                    <div class="text-center mt-4 mb-4">
                                        <img src="assets/images/no_records_found.png" alt="Notification"
                                            class="img-fluid mb-2" style="max-width: 150px;" />
                                        <p>No Records Found!</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </ng-template>
                </table>
            </div>

            <!-- Open Positions -->
            <div class="table-responsive" *ngSwitchCase="'positions'">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Symbol</th>
                            <th>Size</th>
                            <th>Side</th>
                            <th>Available</th>
                            <th>Entry Price</th>
                            <th>Mark Price</th>
                            <th>Unrealized PnL</th>
                            <th>Market Val</th>
                            <th>Close Position</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="10" class="text-center">
                                <app-loader></app-loader>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="!isLoading && orders.length > 0; else noData">
                        <tr *ngFor="let order of filteredOrders">
                            <td>{{ order.createdAt | date:'MM-dd HH:mm:ss' }}</td>
                            <td>{{ order.symbol }}</td>
                            <td>{{ order.quantity }}</td>
                            <td [ngClass]="order.optionSide === 'CALL' ? 'text-success' : 'text-danger'">
                                {{ order.optionSide }}
                            </td>
                            <td>{{ order.quantity | number:'1.2-2' }}</td>
                            <td>{{ toFixedDown(order.entryPrice,order?.priceDecimals || 2) }}</td>
                            <td>{{ toFixedDown(order.markPrice,order?.priceDecimals || 2) }}</td>
                            <td [ngClass]="order.unrealizedPNL > 0 ? 'text-success' : 'text-danger'">{{
                                toFixedDown(order.unrealizedPNL,order?.priceDecimals || 2) }}</td>
                            <td>{{ toFixedDown(order.markValue,order?.priceDecimals || 2) }}</td>
                            <td><button class="botType">Close</button></td>
                        </tr>
                    </tbody>
                    <ng-template #noData>
                        <tbody *ngIf="!isLoading">
                            <tr>
                                <td colspan="9" style="border-color: transparent">
                                    <div class="text-center mt-4 mb-4">
                                        <img src="assets/images/no_records_found.png" alt="Notification"
                                            class="img-fluid mb-2" style="max-width: 150px;" />
                                        <p>No Records Found!</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </ng-template>
                </table>
            </div>


            <!-- Order History -->
            <div class="table-responsive" *ngSwitchCase="'order-history'">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Symbol</th>
                            <th>Type</th>
                            <th>Side</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Filled</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="8" class="text-center">
                                <app-loader></app-loader>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="!isLoading && orders.length > 0; else noData">
                        <tr *ngFor="let order of filteredOrders">
                            <td>{{ order.createdAt | date:'MM-dd HH:mm:ss' }}</td>
                            <td>{{ order.symbol }}</td>
                            <td>{{ order.orderType }}</td>
                            <td [ngClass]="order.side === 'BUY' ? 'text-success' : 'text-danger'">
                                {{ order.side }}
                            </td>
                            <td>{{ order.originalPrice | number:'1.2-2' }}</td>
                            <td>{{ order.originalQty }}</td>
                            <td>{{ order.response?.executedQty || 0 }}</td>
                            <td>{{ order.status }}</td>
                        </tr>
                    </tbody>
                    <ng-template #noData>
                        <tbody *ngIf="!isLoading">
                            <tr>
                                <td colspan="9" style="border-color: transparent">
                                    <div class="text-center mt-4 mb-4">
                                        <img src="assets/images/no_records_found.png" alt="Notification"
                                            class="img-fluid mb-2" style="max-width: 150px;" />
                                        <p>No Records Found!</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </ng-template>
                </table>
            </div>


            <!-- Trade History -->
            <div class="table-responsive" *ngSwitchCase="'trade-history'">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>Date</th>
                            <th>Symbol</th>
                            <th>Type</th>
                            <th>Side</th>
                            <th>Price</th>
                            <th>Quantity</th>
                            <th>Filled</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody *ngIf="isLoading">
                        <tr>
                            <td colspan="8" class="text-center">
                                <app-loader></app-loader>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="!isLoading && orders.length > 0; else noData">
                        <tr *ngFor="let order of filteredOrders">
                            <td>{{ order.createdAt | date:'MM-dd HH:mm:ss' }}</td>
                            <td>{{ order.symbol }}</td>
                            <td>{{ order.orderType }}</td>
                            <td [ngClass]="order.side === 'BUY' ? 'text-success' : 'text-danger'">
                                {{ order.side }}
                            </td>
                            <td>{{ order.originalPrice | number:'1.2-2' }}</td>
                            <td>{{ order.originalQty }}</td>
                            <td>{{ order.response?.executedQty || 0 }}</td>
                            <td>{{ order.status }}</td>
                        </tr>
                    </tbody>
                    <ng-template #noData>
                        <tbody *ngIf="!isLoading">
                            <tr>
                                <td colspan="9" style="border-color: transparent">
                                    <div class="text-center mt-4 mb-4">
                                        <img src="assets/images/no_records_found.png" alt="Notification"
                                            class="img-fluid mb-2" style="max-width: 150px;" />
                                        <p>No Records Found!</p>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </ng-template>
                </table>
            </div>

            <div class="tab-pane mt-2">
                <nav class="primary_pagination" *ngIf="pagination.totalPages > 1">
                    <ul class="pagination">
                        <li class="page-item" [ngClass]="{ disabled: pagination.page == 1 }">
                            <span class="page-link cursor-pointer" aria-label="Previous" (click)="previousPage()">
                                <span aria-hidden="true">&laquo;</span>
                            </span>
                        </li>
                        <li class="page-item" *ngFor="let item of displayedPages">
                            <a class="page-link" [ngClass]="{ active: item == pagination.page }"
                                href="javascript:void(0)" (click)="goToPage(item)">{{ item }}</a>
                        </li>
                        <li class="page-item" [ngClass]="{ disabled: pagination.totalPages == pagination.page }">
                            <span class="page-link cursor-pointer" (click)="nextPage()" aria-label="Next">
                                <span aria-hidden="true">&raquo;</span>
                            </span>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>


    </div>
</div>